import { CustomClaimValue } from "@app/shared";
import { useHasClaim } from "./useHasClaim";

// The device-health alert UI (top-nav bell, Alerts page, per-device Health tab,
// Notifications settings) is superadmin-only for now. Regular users never see
// it, so they can't configure notifications; superadmins own whatever they point
// an alert at. Broaden this if/when we expose alerts to clients.
export function useAlertsUiVisible(): boolean {
    return useHasClaim(CustomClaimValue.SuperAdmin);
}
